import React from "react";
import { LayoutGrid, LayoutGridCell } from "@cdk-uip/react-layout-grid";
import { TextField, TextFieldHelperText } from "@cdk-uip/react-text-field";
import { Radio, RadioGroup } from "@cdk-uip/react-radio";
import { CaptionText } from "@cdk-uip/react-typography";
import { Form } from "@cdk-uip/react-form";
import { Button } from "@cdk-uip/react-button";
import { PHONE_REGEX } from "../config/ValidationPatterns";
import { PageSpinner } from "@cdk-uip/react-page-spinner";
import { SystemMessage } from "@cdk-uip/react-system-messages";
import { Card, CardHeader, CardTitle, CardText } from "@cdk-uip/react-card";
import InvoiceConfiguration from "./InvoiceConfiguration";
import getBrand from "../config/Brand";

import ReactGA from "react-ga";

const brand = getBrand();

const queryString = require("query-string");

class SelfRegistration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cmf: "",
      lastInvoiceNumber: "",
      lastInvoiceAmount: 0.0,

      username: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",

      storeId: "",
      invoiceFormat: "",
      sendMethod: "",
      primaryEmail: "",
      secondaryEmail: "",

      summarySum: true,
      summaryDet: true,
      recurSumDet: true,
      variableSum: true,
      variableDet: true,
      recurSvcDet: false,

      // validation required:
      // 0 - taken validation;
      // 1 - OIM/OIM;
      // 2 - connectCDK;
      // 3 - all validation is fine.
      validationLevel: 0,
    };
    ReactGA.pageview("validate-invoice-start");
  }
  // json object populated from the first validation
  // preferences for cmf
  dealershipName = "";
  username = "";

  componentWillMount() {
    if (this.state.validationLevel === 0) {
      // token validation, take email address from the URL
      //      let tokenPath = this.props.match.params.token;
      let tokenQuery = queryString.parse(this.props.location.search).token;

      this.props.validateToken(tokenQuery);

      this.setState({ validationLevel: 1 });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.validateTokenResult !== prevProps.validateTokenResult) {
      this.username = this.props.validateTokenResult.email;
    }
  }

  onClickClear = (e) => {
    e.preventDefault();
    this.setState({
      cmf: "",
      lastInvoiceNumber: "",
      lastInvoiceAmount: 0.0,
    });
  };

  onClickBack = (e) => {
    e.preventDefault();
    this.setState({ validationLevel: 1 });
  };

  onChangeForm = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  onClickSubmit = (event) => {
    event.preventDefault();
    if (this.state.validationLevel === 1) {
      // Validate against - OIM (cmf, invoice #, anvoice amount); ConnectCDK (cmf)
      // OIM - getValidated, END_POINT/v1/InvValidation?cmf={cmf}&lastInvoiceNumber={lastInvoiceNumber}&lastInvoiceAmount={lastInvoiceAmount}
      this.props.invValidation(this.state).then((body) => {
        if (!this.props.error) {
          this.dealershipName = this.props.invValidationResult.dealershipName;
          ReactGA.pageview("invoice-details-verified");
          this.setState({
            cmf: this.props.invValidationResult.cmf,
            username: this.username,
            email: this.username,

            storeId: this.props.invValidationResult.storeId,
            invoiceFormat: this.props.invValidationResult.invoiceFormat,
            sendMethod: this.props.invValidationResult.sendMethod,
            primaryEmail:
              this.props.invValidationResult.primaryEmail !== "null"
                ? this.props.invValidationResult.primaryEmail
                : "",
            secondaryEmail:
              this.props.invValidationResult.secondaryEmail !== "null"
                ? this.props.invValidationResult.secondaryEmail
                : "",
            summarySum:
              this.props.invValidationResult &&
              this.props.invValidationResult.summarySum !== null
                ? this.props.invValidationResult.summarySum
                : true,
            summaryDet:
              this.props.invValidationResult &&
              this.props.invValidationResult.summaryDet !== null
                ? this.props.invValidationResult.summaryDet
                : true,
            recurSumDet:
              this.props.invValidationResult &&
              this.props.invValidationResult.recurSumDet !== null
                ? this.props.invValidationResult.recurSumDet
                : true,
            variableSum:
              this.props.invValidationResult &&
              this.props.invValidationResult.variableSum !== null
                ? this.props.invValidationResult.variableSum
                : true,
            variableDet:
              this.props.invValidationResult &&
              this.props.invValidationResult.variableDet !== null
                ? this.props.invValidationResult.variableDet
                : true,
            recurSvcDet:
              this.props.invValidationResult &&
              this.props.invValidationResult.recurSvcDet !== null
                ? this.props.invValidationResult.recurSvcDet
                : true,

            validationLevel: 2,
          });
        }
      });
    } else if (this.state.validationLevel === 2) {
      let data = {
        domain: brand.short,
        cmf: this.state.cmf,
        //last invoice Number and last invoice amount are needed in create user api call!
        lastInvoiceNumber: this.state.lastInvoiceNumber,
        lastInvoiceAmount: this.state.lastInvoiceAmount,
        storeId: this.state.storeId,
        username: this.state.username,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        phone: this.state.phone,
        token: queryString.parse(this.props.location.search).token,
        invoiceFormat: this.state.invoiceFormat,
        sendMethod: this.state.sendMethod,
        primaryEmail: this.state.primaryEmail,
        secondaryEmail: this.state.secondaryEmail,
        summarySum: this.state.summarySum,
        summaryDet: this.state.summaryDet,
        recurSumDet: this.state.recurSumDet,
        variableSum: this.state.variableSum,
        variableDet: this.state.variableDet,
        recurSvcDet: this.state.recurSvcDet,
      };

      this.props.registerUser(data).then((body) => {
        this.setState({ validationLevel: 3 });
      });
    }
  };

  getWording = () => {
    return this.state.validationLevel === 1 ? (
      <span>{brand.description}</span>
    ) : (
      <span>
        To continue registration you will need to provide the following
        information.
      </span>
    );
  };

  createMailto = () => {
    let mailto = `mailto:cdkhub.admin@cdk.com?subject=MMI Self-Registration Error&body=Dear Support,%0D%0A%0D%0A An error has occurred registering for manage my invoice on Hub.%0D%0A%0D%0A`;

    let mailBody = "";

    if (queryString.parse(this.props.location.search).token) {
      mailBody +=
        "Token: " +
        queryString.parse(this.props.location.search).token +
        "%0D%0A";
    }
    if (this.username) {
      mailBody += "Email/username: " + this.username + "%0D%0A";
    }
    if (this.state.cmf) {
      mailBody += "CMF: " + this.state.cmf + "%0D%0A";
    }
    if (mailBody !== "") {
      mailBody =
        "<--- For support use --->%0D%0A" +
        mailBody +
        "<--- For support use --->%0D%0A";
    }
    return mailto + mailBody;
  };

  appComponent = () => {
    return (
      <React.Fragment>
        {this.state.validationLevel === 1 && (
          <React.Fragment>
            <LayoutGridCell span={4}>
              <TextField
                name="cmf"
                label="Billing Customer Number"
                helperText={
                  <TextFieldHelperText persistent validation>
                    Must be a numeric and 8 characters long
                  </TextFieldHelperText>
                }
                required
                fullWidth
                pattern="[0-9]{8}"
                value={this.state.cmf}
                onChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={4}>
              <TextField
                name="lastInvoiceNumber"
                label="Last Invoice Number"
                required
                fullWidth
                pattern="[0-9]+"
                helperText={
                  <TextFieldHelperText persistent validation>
                    Must be a numeric value
                  </TextFieldHelperText>
                }
                value={this.state.lastInvoiceNumber}
                onChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={4}>
              <TextField
                name="lastInvoiceAmount"
                label="Last Invoice Amount"
                prefix="$"
                required
                fullWidth
                pattern="^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(\.[0-9][0-9])?$"
                helperText={
                  <TextFieldHelperText persistent validation>
                    Must be a numeric value greater or equal to $0.00
                  </TextFieldHelperText>
                }
                value={this.state.lastInvoiceAmount}
                onChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={12}>
              <Button type="button" onClick={this.onClickClear} primary>
                Clear
              </Button>
              <Button
                type="submit"
                style={{ marginLeft: "16px" }}
                raised
                primary
              >
                Validate
              </Button>
            </LayoutGridCell>
          </React.Fragment>
        )}

        {this.state.validationLevel >= 2 && (
          <React.Fragment>
            <LayoutGridCell span={6}>
              <TextField
                readOnly
                fullWidth
                label="Billing Customer Number"
                value={this.state.cmf}
              />
            </LayoutGridCell>
            <LayoutGridCell span={6}>
              <TextField
                readOnly
                fullWidth
                label="Dealership Name"
                value={this.dealershipName}
              />
            </LayoutGridCell>
            <LayoutGridCell span={6}>
              <TextField
                fullWidth
                name="username"
                label="Username"
                required
                value={this.state.username}
                readOnly={true}
              />
            </LayoutGridCell>
            <LayoutGridCell span={6}></LayoutGridCell>
            <LayoutGridCell span={6}>
              <TextField
                fullWidth
                required
                name="firstName"
                label="First name"
                value={this.state.firstName}
                onChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={6}>
              <TextField
                fullWidth
                required
                name="lastName"
                label="Last name"
                value={this.state.lastName}
                onChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={6}>
              <TextField
                fullWidth
                required
                name="email"
                label="Email"
                value={this.state.email}
                type="email"
                readOnly={true}
              />
            </LayoutGridCell>

            <LayoutGridCell span={6}>
              <TextField
                fullWidth
                required
                name="phone"
                label="Phone"
                value={this.state.phone}
                onChange={this.onChangeForm}
                type="phone"
                pattern={PHONE_REGEX}
                helperText={
                  <TextFieldHelperText persistent validation>
                    Standard US Format
                    <br />
                    For example: 123-456-7890
                  </TextFieldHelperText>
                }
              />
            </LayoutGridCell>
            <LayoutGridCell span={12}>
              <hr />
            </LayoutGridCell>
            <LayoutGridCell span={6}>Invoice Format:</LayoutGridCell>
            <LayoutGridCell span={6}>Delivery Method:</LayoutGridCell>
            <LayoutGridCell span={6}>
              <div id="radioGroup-invoiceFormat" className="ucp-radioGroup">
                <RadioGroup
                  name="invoiceFormat"
                  label="Invoice Format"
                  value={this.state.invoiceFormat}
                  onChange={this.onChangeForm}
                  style={{ display: "flex" }}
                  required
                >
                  <Radio value="Summary">Summary</Radio>
                  <Radio value="Detail">Detail</Radio>
                </RadioGroup>
              </div>
            </LayoutGridCell>
            <LayoutGridCell span={6}>
              <div id="radioGroup-sendMethod" className="ucp-radioGroup">
                <RadioGroup
                  name="sendMethod"
                  label="Send Method"
                  value={this.state.sendMethod}
                  onChange={this.onChangeForm}
                  style={{ display: "flex" }}
                >
                  <Radio value="Email">Email</Radio>
                  <Radio value="Mail">Mail</Radio>
                </RadioGroup>
              </div>
            </LayoutGridCell>

            <LayoutGridCell span={6}>
              <TextField
                name="primaryEmail"
                type="email"
                label="Invoice Primary Email"
                required
                fullWidth
                helperText={
                  <TextFieldHelperText persistent validation>
                    The primary email address your invoices should be sent to.
                  </TextFieldHelperText>
                }
                value={this.state.primaryEmail}
                onChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={6}>
              <TextField
                name="secondaryEmail"
                type="email"
                label="Invoice Secondary Email"
                fullWidth
                helperText={
                  <TextFieldHelperText persistent validation>
                    An optional secondary email address your invoices should be
                    sent to.
                  </TextFieldHelperText>
                }
                value={this.state.secondaryEmail}
                onChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={12}>
              <InvoiceConfiguration
                config={this.state}
                handleChange={this.onChangeForm}
              />
            </LayoutGridCell>
            <LayoutGridCell span={12}>
              <Button type="button" onClick={this.onClickBack} primary>
                Back
              </Button>
              <Button
                type="submit"
                style={{ marginLeft: "16px" }}
                raised
                primary
              >
                Create
              </Button>
            </LayoutGridCell>
          </React.Fragment>
        )}
        <LayoutGridCell span={12}>
          <CaptionText>* Asterisk indicates required fields</CaptionText>
        </LayoutGridCell>
      </React.Fragment>
    );
  };

  render() {
    return (
      <LayoutGrid>
        {this.props.validateTokenProcessing && (
          <PageSpinner show={this.props.validateTokenProcessing} />
        )}

        {!this.props.validateTokenProcessing && this.props.error && (
          <React.Fragment>
            <LayoutGridCell spanDesktop={2} spanTablet={0} spanPhone={0} />
            <LayoutGridCell span={8}>
              <SystemMessage critical className="">
                <React.Fragment>
                  {this.props.error}{" "}
                  {this.props.errorCode === 1 ? (
                    <React.Fragment>
                      If the problem persists please contact our{" "}
                      <a href={this.createMailto()}>support team</a>. If you
                      have questions or need further assistance please contact
                      866.510.5103.
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              </SystemMessage>
            </LayoutGridCell>
            <LayoutGridCell spanDesktop={2} spanTablet={0} spanPhone={0} />
          </React.Fragment>
        )}

        {!this.props.validateTokenProcessing && this.props.validateTokenResult && (
          <React.Fragment>
            <LayoutGridCell spanDesktop={2} spanTablet={0} spanPhone={0} />
            <LayoutGridCell span={8}>
              {(this.state.validationLevel !== 3 ||
                (this.state.validationLevel === 3 && !this.props.error)) && (
                <Card>
                  {this.state.validationLevel === 3 ? (
                    <React.Fragment>
                      {!this.props.error && (
                        <React.Fragment>
                          {ReactGA.pageview("registration-successful")}
                          <CardHeader>
                            <CardTitle large>
                              Registration was successfully completed
                            </CardTitle>
                          </CardHeader>
                          <CardText>
                            <div id="verification-sent">
                              {brand.verificationSentText}
                            </div>
                          </CardText>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <CardHeader>
                        <CardTitle large>{brand.title}</CardTitle>
                      </CardHeader>
                      <CardText>
                        {this.getWording()}
                        <Form onSubmit={this.onClickSubmit}>
                          <LayoutGrid nested span={12}>
                            {this.appComponent()}
                          </LayoutGrid>
                        </Form>
                      </CardText>
                    </React.Fragment>
                  )}
                </Card>
              )}
            </LayoutGridCell>
            <LayoutGridCell spanDesktop={2} spanTablet={0} spanPhone={0} />
          </React.Fragment>
        )}
      </LayoutGrid>
    );
  }
}

export default SelfRegistration;
